import { PropertyPhotosResponse } from "../types/propertyPhotos";
import { createCloudRunAxios } from "./axios";

const photosApi = createCloudRunAxios("valuationPhotos");

export interface PhotosResult {
  primaryPhoto?: string;
  additionalPhotos: string[];
  photoCount: number;
}

/**
 * Fetches property photos from the valuation photos API
 * @param address Full property address
 */
export async function fetchPropertyPhotos(
  address: string
): Promise<PhotosResult> {
  const response = await photosApi.post<PropertyPhotosResponse>("/photos", {
    address,
  });

  if (response.data.status === "error" || !response.data.data) {
    throw new Error(response.data.message || "Failed to fetch photos");
  }

  const { photos } = response.data.data;
  const sortedPhotos = [...photos].sort((a, b) => a.order - b.order);

  return {
    primaryPhoto: sortedPhotos[0]?.url,
    additionalPhotos: sortedPhotos.slice(1).map((photo) => photo.url),
    photoCount: sortedPhotos.length,
  };
}

/**
 * Formats an address object into a string
 */
export function formatAddress(address: {
  address?: string;
  city?: string;
  state?: string;
  postalCode?: string;
}): string {
  const parts = [
    address.address,
    address.city,
    address.state,
    address.postalCode,
  ].filter(Boolean);

  return parts.join(", ");
}
